(function () {
  'use strict';

  angular.module('dashboard.stock').factory('DashboardStock', DashboardStock);

  DashboardStock.$inject = ['$resource'];

  function DashboardStock($resource) {
    return $resource(
      '/api/',
      {},
      {
        getStock: {
          method: 'GET',
          url: '/api/dashboard/statistic/assortment',
          cache: true,
          interceptor: {
            response: function (response) {
              return response.data;
            },
          },
        },
      },
    );
  }
})();
